import React, { useContext } from "react";
import { lensPath, map, set } from "ramda";
import { MediaContext } from "../../common/media-context";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

const types = [
  { label: "Article", value: "ARTICLE" },
  { label: "Audio", value: "AUDIO" },
  { label: "Audiobook", value: "AUDIOBOOK" },
  { label: "Book", value: "BOOK" },
  { label: "Document", value: "OTHER_DOCUMENT" },
  { label: "Image", value: "IMAGE" },
  { label: "Video", value: "VIDEO" },
];

const MediaTypeSelect = () => {
  const context = useContext(MediaContext);
  const handleTypeChange = event => {
    const type = event.target.value;
    context.setMedia(prev => set(lensPath(["type"]), type, prev));
    context.setErrors({});
  };
  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="upload-media-type">Media Type</InputLabel>
      <Select
        labelId="upload-media-type"
        id="media-type"
        value={context.media.type}
        onChange={handleTypeChange}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      >
        {map(
          type => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ),
          types,
        )}
      </Select>
    </FormControl>
  );
};

export default MediaTypeSelect;
